<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionSectionNavigationMenuDropDownSearch"
  >
    <section class="m-dropdown-section">
      <ul class="m-dropdown-list">
        <li
          v-for="resultado in resultados"
          :key="resultado.id"
        >
          <a
            href="#"
            @click.prevent="goToNode(resultado)"
          >
            <span class="ellipsis m-dropdown-item-text">
              {{ resultado.nombre }}
            </span>
          </a>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPayments',

  props: {
    info: {
      type: Object,
      default: null
    },

    resultados: Array
  },

  methods: {
    goToNode (nodo) {
      this.$store.commit('setSelectedNode', nodo)
      this.$router.push(`/${this.$t('rPaths.asset')}/${this.$route.params.id}/${this.$t('mEditionMenu.asset.content.subject')}/${nodo.id}/${this.$t('mEditionMenu.asset.content.children.node.subedition')}`)
      this.$dropDown.closeDropDown('MoleculeEditionSectionNavigationMenuDropDownSearch')
    }
  }
}
</script>
